module.exports = __webpack_public_path__ + "static/media/button_join_CTV_2.3a7274d8.png";